import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoggingService } from '@logging/logging.service';
import { AuthenticationService } from '@auth/authentication.service';
import { TokenRefreshService } from '@auth/token-refresh/token-refresh-service';

/**
 * Prevents users accessing views that are for authenticated users only e.g. dash board and module pages
 * Redirects to the login if accessed.
 */
@Injectable({ providedIn: 'root' })
export class AuthenticatedRouteGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private tokenRefreshService: TokenRefreshService,
    private logger: LoggingService
  ) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.tokenRefreshService.ensureAuthenticated$().pipe(
      map((authenticated) => {
        if (authenticated) {
          return true;
        }

        this.logger.trace('AuthenticatedRouteGuard: No authenticated access. Redirecting.');
        this.authenticationService.signOutAndRedirect();
        return false;
      })
    );
  }
}
